import $ from "jquery"

const wooproduct = () => {
  const init = () => {
    giftCard()
  }

  const buttton = $(".WooProduct .product type-product .button")
  const wrapper = $(".WooProduct .woocommerce-LoopProduct-link")

  const giftCard = () => {
    if (wrapper.length === 0) return
    buttton.wrap(wrapper)
  }

  init()
}
wooproduct()
